import { ShieldCheck, Crosshair, Share2, Lock } from "lucide-react";
import { PILLARS } from "@/data/site";

const ICONS = { ShieldCheck, Crosshair, Share2, Lock };

export default function BrandPillars() {
  return (
    <section
      data-testid="brand-pillars"
      className="relative py-20 sm:py-24 bg-[#030710] border-b border-slate-800/80"
    >
      <div className="absolute inset-0 bek-grid opacity-20" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {PILLARS.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <div
                key={p.name}
                data-testid={`pillar-${p.name.toLowerCase()}`}
                className="group flex items-start gap-5 p-6 border border-slate-800/80 bg-[#080F1C]/70 hover:border-slate-300/40 transition-colors relative"
              >
                <span className="shrink-0 w-14 h-14 grid place-items-center border border-slate-300/40 rounded-sm bg-[#050912] group-hover:border-slate-300 transition-colors">
                  <Icon className="w-7 h-7 text-slate-300" />
                </span>
                <div className="min-w-0">
                  <div className="text-white font-semibold tracking-tight text-lg uppercase">
                    {p.name}
                  </div>
                  <div className="text-slate-300 text-xs font-mono-tech tracking-[0.25em] uppercase mt-1">
                    {p.tagline}
                  </div>
                  <div className="mt-3 text-sm text-slate-400 leading-relaxed">{p.desc}</div>
                </div>
                <span className="absolute top-3 right-3 font-mono-tech text-[10px] text-slate-700">
                  0{i + 1}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
